export const GENERATED_ASSESSMENT_EVENTS = {
  CLICKED_VIEW: 'Clicked View Generated Assessment',
  DELETED: 'Deleted Generated Assessment',
  CLICKED_GENERATE: 'Clicked Generate Assessment',
  GENERATION_COMPLETED: 'Assessment Generation Completed'
}
